import { useState } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import React from "react";
import { TablePaginate } from "../../../layout/Datagrid/TablePaginate";
import { useNavigate } from "react-router-dom";

import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import MyEditor from "../../../services/EditorTexto";
import { Toast } from "../../../layout/Alerta";
import axios from "axios";
import Swal from "sweetalert2";




const SolicitudCalculosPE = () => {
    const [fecha, setFecha] = useState<dayjs.Dayjs | null>(dayjs());
    const [titulo, setTitulo] = useState<string>("");
    const BASEURL = `${process.env.REACT_APP_APPLICATION_ENDPOINT}/participaciones/estatales/memorias/`;
    const [formula, setFormula] = useState<string>("");
    const navigate = useNavigate();
    const TITULO = "Solicitud de Alta Participaciones Estatales Cálculos";
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const crearMemoria = async () => {
        // Validaciones previas
        if (!titulo.trim() || !formula.trim() || !fecha) {
            await Swal.fire({
                title: "Campos incompletos",
                text: "Por favor, completa todos los campos requeridos.",
                icon: "warning",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#15212f",
            });
            return;
        }

        // Confirmación antes de guardar
        const confirmacion = await Swal.fire({
            title: "¿Estás seguro?",
            text: "Esta acción guardará la memoria de cálculo.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sí, guardar",
            confirmButtonColor: "#15212f",
            cancelButtonColor: "#bda889",
            cancelButtonText: "Cancelar",
        });

        if (!confirmacion.isConfirmed) {
            return;
        }

        try {
            const token = localStorage.getItem("jwtToken");

            const response = await axios.post(
                `${BASEURL}alta`,
                {
                    titulo: titulo.trim(),
                    formula: formula.trim(),
                    orden: 0,
                    fecha: fecha?.toISOString(), // Asegura formato correcto
                },
                {
                    headers: {
                        Authorization: `${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.success) {
                await Swal.fire({
                    title: "Guardado exitoso",
                    text: "La memoria de cálculo se ha guardado correctamente.",
                    icon: "success",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#15212f",
                });

                navigate("/admin/participaciones/estatales/memoriasdecalculo");
            } else {
                throw new Error("Respuesta no exitosa del servidor");
            }
        } catch (error) {
            await Swal.fire({
                title: "Error",
                text: "¡No se logró guardar la información!",
                icon: "error",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#15212f",
            });
        }
    };

    return (

        <Grid container sx={{}}>
            <Grid item mb={2} width={"100%"}>
                <BreadcrumbBar
                    links={[
                        { texto: "Inicio", link: "/admin" },
                        { texto: "Cálculos", link: "/admin/participaciones/estatales/memoriasdecalculo" },

                    ]}
                    Titulo={TITULO}
                />
            </Grid>
            <Grid item width={"100%"} >

                <Typography
                    variant="h5"
                    component="div"
                    sx={{
                        flexGrow: 1,
                        fontWeight: "bold",
                        display: "flex",
                        justifyContent: "left",
                        marginBottom: "0.5rem"
                    }}

                >
                    {TITULO}
                </Typography>

            </Grid>

            <Grid container mb={2} width={"100%"} display={"flex"} justifyContent={"space-between"}>
                <Grid item xs={12} sx={{ marginBottom: "1rem" }}>
                    <p style={{ fontWeight: "bold" }}>
                        Nota: Por favor, asegúrese de llenar todos los campos obligatorios antes de guardar la información.
                    </p>
                </Grid>
            </Grid>


            <Grid container item xs={12} spacing={2} sx={{ display: "flex", justifyContent: "space-between", marginBottom: "1rem" }}>
                <Grid item xs={12} md={5.5}>
                    <TextField
                        label="Título"
                        sx={{ width: "100%" }}
                        value={titulo}
                        onChange={(e) => setTitulo(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} md={5.5}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Fecha"
                            value={fecha}
                            onChange={(newValue) => setFecha(newValue)}
                            renderInput={(params) => <TextField  {...params} fullWidth sx={{ width: "100%" }} />}
                        />
                    </LocalizationProvider>
                </Grid>
            </Grid>

            <Grid container width={"100%"}>
                <MyEditor content={formula} setContent={setFormula} />
            </Grid>

            <Grid
                container
                justifyContent={{ xs: "center", md: "flex-end" }}
                spacing={2}
                direction={{ xs: "column", sm: "row" }}
                sx={{ mt: 2 }}
            >
                <Grid item>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() =>
                            navigate("/admin/participaciones/estatales/memoriasdecalculo")
                        }
                        sx={{
                            backgroundColor: "#C1A25C",
                            textTransform: "capitalize",
                            width: { xs: "100%", sm: "7rem" },
                        }}
                    >
                        Cancelar
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={crearMemoria}
                        sx={{
                            textTransform: "capitalize",
                            width: { xs: "100%", sm: "7rem" },
                        }}
                    >
                        Guardar
                    </Button>
                </Grid>
            </Grid>

        </Grid >
    );
};

export default SolicitudCalculosPE;
